import React from "react";
import Autoplay from "embla-carousel-autoplay";
import useEmblaCarousel from "embla-carousel-react";

const defaultOptions = { axis: "y", dragFree: true, loop: true };

const VerticalCarousel = ({ options = {}, slides = [] }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      ...defaultOptions,
      ...options,
    },
    [Autoplay({ delay: 10000 })]
  );

  return (
    <section className="embla">
      <div className="embla__viewport" ref={emblaRef}>
        <div
          className="embla__container"
          style={{
            height: options.slideHeight || "",
          }}
        >
          {slides.map((slide, index) => (
            <div className="embla__slide" key={index}>
              {slide}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VerticalCarousel;
